import { JsonRestApiRequestConfig, makeJsonRestApiRequest } from '~src/httpClient/RestApiService';

export function callUpdateWorkbookRevisionMetadata(
  workbookId: string,
  versionNumber: number,
  notes: string
): Promise<void> {
  const config: JsonRestApiRequestConfig = {
    restApiVersion: '3.30',
    httpMethod: 'PATCH',
    endpoint: `workbooks/${workbookId}/revisions/${versionNumber}/metadata`,
    serverWideRequest: false,
  };
  return makeJsonRestApiRequest<{ notes: string }, void>({ config, request: { notes } });
}
